import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Components/Login'
import Dashboard from './Components/Dashboard';
import AllCards from './Components/AllCards';
import BingoCardsPage from './Components/BingoCards/BingoCardsPage';
import GamePage from './Components/GamePage';
import Report from './Components/Reports';
import Zola from './Components/Zola';
function App() {
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/all-cards" element={<AllCards />} />
        <Route path="/bingo-cards" element={<BingoCardsPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/game-in-progress" element={<GamePage />} />
        <Route path="/reports" element={<Report />} />
        <Route path="/manage/zola" element={<Zola />} /> 
        <Route path="/mp" element={<Zola allowSuperTopUp />} /> 
      </Routes>
    </BrowserRouter>
  );
}

export default App;
